var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MinMaxInputStyled', [_c('div', [_vm._v(_vm._s(_vm.$t('planning.min')))]), _c('div', {
    staticClass: "input"
  }, [_c('InputStyled', {
    attrs: {
      "type": "number",
      "min": "0",
      "value": _vm.min
    },
    on: {
      "input": function input($event) {
        _vm.$emit('update:min', Number($event.target.value));
      }
    }
  }), _vm.unit ? _c('div', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()], 1), _c('div', [_vm._v(_vm._s(_vm.$t('planning.max')))]), _c('div', {
    staticClass: "input"
  }, [_c('InputStyled', {
    attrs: {
      "type": "number",
      "min": Number(_vm.min) + 1,
      "value": _vm.max
    },
    on: {
      "input": function input($event) {
        _vm.$emit('update:max', Number($event.target.value));
      }
    }
  }), _vm.unit ? _c('div', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }